<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<div *ngIf='map()' data-testid="place-autocomplete-wrapper">
  <p-floatlabel variant="on">
    <bs-autocomplete inputId='addressInput'
                    bsFloatLabelCompat
                    data-testid="place-autocomplete"
                    [disabled]='disabled()'
                    [ngModel]='value()'
                    (selected)='onPlaceClick($event)'
                    [items]='predictions()'
                    (queryChange)='onAddressInput($event)'
                    [requireSelection]='true'
                    [displayWith]='getDisplayLabel'
                    [compareWith]='compareByDescription'
                    [minLength]='1'>
    </bs-autocomplete>
    <label for='addressInput'>{{ label() }}</label>
  </p-floatlabel>
</div>
